/* tpl-mat-pair-price.js (2026-10-30, round 5): keeps the pair pill
   (2 for / struck full price) on the selected variant, shows the
   "Build a pair" link only when #pair exists, scrolls to it, hides the pill
   after the offer ends. The amount and end come from the markup (JSON printed
   by snippets/tpl-mat-pair-price.liquid from snippets/tpl-mat-pair-offer.liquid),
   never from this file. Vanilla, no loops. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tpl-mpp]');
  if (!root || root.__mpp) return;
  root.__mpp = true;
  var dataEl = document.querySelector('[data-tpl-mpp-data]');
  var data = {};
  try { data = JSON.parse(dataEl.textContent); } catch (e) { root.hidden = true; return; }
  var END_MS = (Number(data.end) || 0) * 1000;
  var OFF = Number(data.off) || 0; /* cents, from the markup */
  if (!OFF || (END_MS && Date.now() > END_MS)) { root.hidden = true; return; }

  var SLOTS = ['data-tpl-mpp-money', 'data-tpl-mpp-was'];

  function bucks() {
    try { if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') window.bucksCC.reConvert(); } catch (e) {}
  }

  function currentId() {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    var input = form && form.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }

  /* Bucks rewrites .money spans in place; swap in fresh shop-format spans and
     let it convert them again (same pattern as round 3). */
  function put(attr, text) {
    var old = root.querySelector('[' + attr + ']');
    if (!old || !text) return;
    var span = document.createElement('span');
    span.className = 'money';
    span.setAttribute(attr, '');
    span.textContent = text;
    old.replaceWith(span);
  }

  var last = '';
  function sync() {
    var id = currentId();
    var row = data.v && data.v[id];
    if (!id || id === last || !row) return;
    last = id;
    for (var i = 0; i < SLOTS.length; i++) put(SLOTS[i], row[i]);
    bucks();
  }

  /* #pair only exists once the pair builder is live (after launch). */
  function settle() {
    var link = root.querySelector('[data-tpl-mpp-link]');
    if (link) link.hidden = !document.getElementById('pair');
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') sync();
  });
  try {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
    }
  } catch (e) {}

  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-tpl-mpp-link]');
    if (!a) return;
    var target = document.getElementById('pair');
    if (!target) return;
    e.preventDefault();
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    try { window.tplTrack && window.tplTrack('tpl_pair_price_tap', { variant_id: currentId(), off: OFF / 100 }); } catch (err) {}
  });

  settle();
  sync();
  window.addEventListener('load', function () { settle(); bucks(); }, { once: true });
})();
